import { AdminInvestor } from 'api';
import React, { FunctionComponent, useEffect, useState } from 'react';
import Checkbox from 'ui/atoms/checkbox';
import Hint from 'ui/atoms/hint';
import Translate from 'ui/atoms/translate';

export interface DeleteConfirmProps {
  investor: AdminInvestor;
  onChangeConfirm: (isConfirmed: boolean) => void;
}

const DeleteConfirm: FunctionComponent<DeleteConfirmProps> = (props) => {
  const { investor, onChangeConfirm } = props;

  const [isConfirmed, setIsConfirmed] = useState(false);

  useEffect(() => {
    onChangeConfirm(isConfirmed);
  }, [isConfirmed]);

  return (
    <div>
      <Hint variant="warning">
        {investor.distributionPlatform.hasFrontend ? (
          <div>
            <div>
              <Translate name="dashboardIssuerInvestorDetails.deleteAccount.content1" />
            </div>
            <div>
              <Translate name="dashboardIssuerInvestorDetails.deleteAccount.content2" />
            </div>
            <div>
              <Translate name="dashboardIssuerInvestorDetails.deleteAccount.content3" />
            </div>
          </div>
        ) : (
          <div>
            <Translate name="dashboardIssuerInvestorDetails.deleteAccount.contentNoFrontend" />
          </div>
        )}
      </Hint>

      <Checkbox checked={isConfirmed} onChange={() => setIsConfirmed(!isConfirmed)}>
        <Translate
          name="dashboardIssuerInvestorDetails.deleteAccount.confirmDeletion"
          args={[investor!.investorName]}
        />
      </Checkbox>
    </div>
  );
};

export default DeleteConfirm;
